import { AUNOA_BOT_URL, AUNOA_BOT_USER_KEY } from '@/config';
import { DEFAULT_MISSING_EMAIL } from '@/config/appConstants';
import { BillingDetails } from '@/features/billing';
import { Me } from '@/types';

export type AunoaProps = {
  titleMark?: string;
  callback: () => void;
  name: string;
  email: string;
  gruId: string;
  type: string;
  salesarea: string;
};

export const loadAunoa = ({ callback, name, email, gruId, type, salesarea }: AunoaProps) => {
  const scriptId = 'AUNOA_BOT';
  const existingScript = document.getElementById(scriptId);

  if (!existingScript && AUNOA_BOT_URL && AUNOA_BOT_USER_KEY) {
    window.AUNOA_USER_DATA = {
      idnombre: name,
      idemail: email,
      idgru: gruId,
      idtipo: type,
      idsales: salesarea,
    };

    const script = document.createElement('script');
    script.src = AUNOA_BOT_URL + AUNOA_BOT_USER_KEY;
    script.id = scriptId;
    document.body.appendChild(script);

    script.onload = () => {
      callback && callback();
    };
  }
  if (existingScript && callback) callback();
};

export const getAunoaInitData = (me: Me, billingDetails: BillingDetails) => {
  return {
    callback: () => console.info('Aunoa BOT loaded.'),
    name: me.userInfo.name + ' ' + me.userInfo.lastName,
    email: me.userInfo.email || DEFAULT_MISSING_EMAIL,
    gruId: me.userInfo.groupId,
    type: me.userInfo.rolId,
    salesarea: billingDetails.countryId,
  };
};
